import { BackendEnum } from "@c2b/commons";
import { EnviromentEnum } from '@/utils/constants/EnviromentEnum';

export interface SubscriberBackendMonitor {
    isBackendShop():boolean
    isBackendBimer():boolean
}

export class SubscriberModel {
    publicKey:string = ''
    name:string = ''
    document:string = ''
    agreementLink:string = ''
    enviroment: EnviromentEnum = EnviromentEnum.PRD
    backend:ISubscriberBackend = {
        id: undefined,
        name: ""
    }

    constructor(s?:Partial<SubscriberModel>) {
        Object.assign(this, s)
    }

    isEnviromentHML():boolean {
        return this.enviroment === EnviromentEnum.HML
    }

    hasSamePublicKey(publicKey:string):boolean {
        if (!this.publicKey || !publicKey) {
            return false
        }

        return this.publicKey === publicKey
    }

    isBackendShop(): boolean {
        return this.backend.id === BackendEnum.SHOP.id;
    }

    isBackendBimer(): boolean {
        return this.backend.id === BackendEnum.BIMER.id;        
    }

    isBackendMuven(): boolean {
        return this.backend.id === BackendEnum.MUVEN.id;        
    }

    isBackendInterfacenet(): boolean {
        return this.backend.id === BackendEnum.INTERFACENET.id;        
    }

    getBackendName():string {
        return this.backend.name
    }

    hasAgreementLink():boolean {
        return !!this.agreementLink
    }
}

interface ISubscriberBackend {
    id?:number
    name:string
}
